<template>
  <div class="nursinghandoverlog">
    <!-- 交班日志 -->
    <el-row>
      <el-row class="row-title">
        <el-col :span="2" align="right" style="margin-right:5px;">
          <kt-button label="上一天" type="primary" @click="handlePrevDay" />
        </el-col>
        <el-col :span="4">
          <el-date-picker :editable="false" :clearable="false" v-model="dateValue" type="date" value-format="yyyy-MM-dd"
            @change="changeDate" placeholder="请选择日期"></el-date-picker>
        </el-col>
        <el-col :span="2">
          <kt-button label="下一天" type="primary" @click="handleNextDay" />
        </el-col>
      </el-row>
    </el-row>
    <el-row v-for="(item, index) in handoverLogList" :key="index">
      <!-- by guo 2019-8-30 11:50 shifts==0为是  是否交接班  显示    shifts==1为否   隐藏 -->
      <!-- by guo 2019-12-18-14:00 变更  shift==1为是  是否交接班 显示   shifts==0为否  隐藏  -->
      <!-- v-if="item.shifts==0" 变更为 v-if="item.shifts==1"-->
      <el-row v-if="item.shifts == 1"
        style="height:54px;line-height:54px;background:#F9F7FA;border:1px #F1EFF2 solid;margin-top:20px;">
        <el-col :span="4" style="font-size:18px;">
          <img src="@/assets/beadhouse/juxing.png" alt style="vertical-align:middle;margin:0 10px;" />
          <!-- <span>{{item.name}}</span> -->
          <span>{{ item.name }}</span>
        </el-col>
      </el-row>
      <el-row v-if="item.shifts == 1">
        <el-form :model="dataForm" label-width="100px" style="margin-top:30px;" :rules="dataFormRules" ref="dataForm"
          label-position="right">
          <el-form-item :label="item.firstLineName" prop="nurse">
            <el-input v-model.trim="item.realName" auto-complete="off" :disabled="true" placeholder
              style="width:85%"></el-input>
          </el-form-item>
          <el-form-item :label="nursingHandoverLog.dataException" prop="dataException">
            <el-input v-model.trim="item.dataException" type="textarea" :disabled="true" :rows="4" auto-complete="off"
              placeholder style="width:85%"></el-input>
          </el-form-item>
          <el-form-item :label="nursingHandoverLog.mainAnomaly" prop="mainException">
            <el-input v-model.trim="item.mainExc" type="textarea" maxlength="256" :disabled="isBefore" :rows="5"
              auto-complete="off" placeholder style="width:85%"></el-input>
          </el-form-item>
          <el-form-item :label="nursingHandoverLog.other" prop="other">
            <el-input v-model.trim="item.other" type="textarea" maxlength="512" :disabled="isBefore" :rows="5"
              auto-complete="off" placeholder style="width:85%"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
    </el-row>
    <el-row>
      <div align="center" style="margin:30px 0;">
        <el-button v-if="btnShow" type="primary" :size="size" @click.native="handleSure"
          :loading="submitLoading">提交</el-button>
      </div>
    </el-row>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "NursingHandoverLog",
  components: { KtButton },
  data() {
    return {
      nursingHandoverLog: {
        dataException: "数据异常",
        mainAnomaly: "主要异常情况",
        other: "其它",
        messageMainExc: "主要异常情况不能超过256个字符",
        messageOther: "其他不能超过512个字符"
      }, //引入 lang 里面的字符串资源,
      nursingGroupId: "", //护工组id
      size: "medium", //按钮的尺寸
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      dataForm: {},
      dataFormRules: {},
      queryShiftLog: [], //判断是否有交班日志
      handoverLogList: [], //数据源
      submitLoading: false, //提交按钮的loading
      btnShow: true, //提交按钮的显示和隐藏
      isBefore: false
    };
  },
  methods: {
    /* 
      时间选择框的change事件
    */
    changeDate(val) {
      this.selectPlans(); //交班班次查询
      //延迟加载 否则数据不显示
      this.$nextTick(() => {
        setTimeout(() => {
          this.selectByDate(); //按日期查询交班日志
        }, 100);
      });
    },

    /* 
      上一天
    */
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      console.log(doday);
      doday = Date.parse(doday);
      console.log(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue);
      this.selectPlans(); //交班班次查询
      //延迟加载 否则数据不显示
      this.$nextTick(() => {
        setTimeout(() => {
          this.selectByDate(); //按日期查询交班日志
        }, 100);
      });
    },

    /* 
      下一天
    */
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      console.log(doday);
      doday = Date.parse(doday);
      console.log(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue);
      this.selectPlans(); //交班班次查询
      //延迟加载 否则数据不显示
      this.$nextTick(() => {
        setTimeout(() => {
          this.selectByDate(); //按日期查询交班日志
        }, 100);
      });
    },

    /* 
       交班日志--添加  和  修改   需要去判断当天的交班日志是否生成   未生成 是 添加   否则  是  修改
    */
    handleSure() {
      console.log(this.queryShiftLog, this.handoverLogList, "----------------");
      //当this.queryShiftLog==null 为添加
      if (this.queryShiftLog.length == 0) {
        console.log("添加----------");
        let params = []; //空数组，用来存放提交的数据
        this.handoverLogList.forEach(item => {
          let paramsObj = {};
          paramsObj.shiftsId = item.shiftsId * 1;
          paramsObj.user = item.user;
          paramsObj.mainExc = item.mainExc == null ? '' : item.mainExc;
          paramsObj.other = item.other == null ? '' : item.other;
          paramsObj.time = item.time;
          paramsObj.realName = item.realName;
          paramsObj.date = this.dateValue;
          paramsObj.nursingGroupId = this.nursingGroupId * 1;
          params.push(paramsObj); //将循环所得到的数据push到params数组中
        });
        console.log(params);
        if (this.checkHandoverNoEmpty(params) != false) {
          this.submitLoading = true;
          this.$postJson("omc/shiftLog/add", params).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.submitLoading = false;
            this.selectByDate();
          });
        }
      } else {
        //否则为 修改
        console.log("修改----------", this.handoverLogList);
        let params = []; //空数组，用来存放提交的数据
        this.handoverLogList.forEach(item => {
          let paramsObj = {};
          // paramsObj.id = item.id * 1;
          paramsObj.id = item.shiftsId * 1;
          paramsObj.user = item.user;
          paramsObj.mainExc = item.mainExc == null ? '' : item.mainExc;
          paramsObj.other = item.other == null ? '' : item.other;
          paramsObj.nursingGroupId = this.nursingGroupId * 1;
          params.push(paramsObj); //将循环所得到的数据push到params数组中
        });
        console.log(params);
        if (this.checkHandoverNoEmpty(params) != false) {
          this.submitLoading = true;
          this.$postJson("omc/shiftLog/edit", params).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.submitLoading = false;
            this.selectByDate();
          });
        }
      }
    },

    /* 
      交班日志--交班班次查询
    */
    selectPlans() {
      let params = {};
      params.nursingGroupId = this.nursingGroupId * 1;
      params.date = this.dateValue;
      console.log(params);
      this.handoverLogList = [];
      this.$postJson("omc/shiftLog/selectPlans", params).then(res => {
        console.log(res, "查询交班日志");
        if (res.result.length > 0) {
          res.result.forEach(item => {
            let handoverLogObj = {};
            handoverLogObj.shifts = item.shifts; //by guo 2019-08-30 11:50 是否交接班   0是   1否   为否的话 页面上就隐藏    by guo 2019-12-18 14:02 1-是  0-否 
            handoverLogObj.name = item.name;
            handoverLogObj.time = item.time;
            handoverLogObj.shiftsId = item.id;
            handoverLogObj.firstLineName = item.name + "护理人员";
            handoverLogObj.realName = item.userNameString;
            handoverLogObj.user = item.userIdString;
            handoverLogObj.mainExc = ""; //主要异常情况
            handoverLogObj.other = ""; //其他
            handoverLogObj.dataException = ""; //数据异常
            this.handoverLogList.push(handoverLogObj);
            //this.selectMainExc(item.time); //查询数据异常  by guo 2019-11-25-18:49修改  异常报告后端直接通过omc/shiftLog/selectPlans返回了 无需再间接去调另外一个接口去查询
          });
          console.log(this.handoverLogList, "****************");
        }
      });
    },

    /* 
      交班日志--按日期查询
    */
    selectByDate() {
      let today = new Date(util.formatDate.format(new Date(), "yyyy-MM-dd"));
      // if (new Date(this.dateValue) >= today) {
      //今日之前不能提交交班日志 by xiang
      // this.isBefore = false;
      let params = {};
      params.nursingGroupId = this.nursingGroupId * 1;
      params.date = this.dateValue;
      console.log(params);
      this.$postJson("omc/shiftLog/selectByDate", params).then(res => {
        console.log(res);
        this.queryShiftLog = res.result; //this.queryShiftLog用来判断是否提交了交班日志
        console.log(this.queryShiftLog);
        if (res.code == 200) {
          this.btnShow = true;
          //by guo 2019-12-02-16:26修改
          if (res.result.length > 0) {
            // if (res.result) {
            res.result.forEach(item => {
              console.log(item, this.handoverLogList);
              this.handoverLogList.forEach(temp => {
                if (item.shiftsId == temp.shiftsId) {
                  temp.mainExc = item.mainExc;
                  temp.other = item.other;
                  temp.id = item.id; //修改交班日志时需要传的id
                  //by guo 2019-11-25-18:55 添加  查询数据异常  直接通过这个查询出来
                  temp.dataException = (item.alertInfo == null || item.alertInfo == undefined || item.alertInfo == '') ? '' : item.alertInfo;
                  //by guo 2019-12-02-16:19添加  今天之前的并且提交了排班计划的  护理人员的姓名才从后端返回的接口数据中获取  item.realName不能为空 
                  if (new Date(this.dateValue) < today && item.realName != '') {
                    temp.realName = item.realName;
                  }
                }
              });
            });
          }
          //如果shifts都为1--否 去掉提示 by xiang 2019-11-25
          //如果shifts都为0 --否 去掉提示 by guo  2019-12-18修改  
          let isShow = false;
          for (var i = 0; i < this.handoverLogList.length; i++) {
            // if (this.handoverLogList[i].shifts == 0) {
            // by guo 2019-12-18-14:05 修改
            if (this.handoverLogList[i].shifts == 1) {
              isShow = true;
              break;
            }
          }
          if (isShow) {
            this.btnShow = true;
          } else {
            this.btnShow = false;
            this.$message({ message: "暂无需要交接班的班次", type: "error" })
          }
          //by guo 2019-11-27-11:16 修改 把上面的代码移到下面来
          console.log(new Date(this.dateValue), today, "比较时间", new Date(this.dateValue) >= today)
          if (new Date(this.dateValue) >= today) {
            if (isShow == true) {
              this.$set(this, "btnShow", true);
            } else {
              this.$set(this, "btnShow", false);
            }
            this.$set(this, "isBefore", false);
          } else {
            this.$set(this, "btnShow", false);
            this.$set(this, "isBefore", true);
          }
          console.log(this.btnShow, this.isBefore);
        } else {
          this.$message({ message: res.message, type: "error" });
          this.btnShow = false;
        }
      });
    },

    /* 
      交班日志--异常情况查询
    */
    selectMainExc(shiftTime) {
      let params = {};
      params.shiftTime = shiftTime;
      params.nursingGroupId = this.nursingGroupId;
      params.date = this.dateValue;
      console.log(params);
      this.$postJson("omc/shiftLog/selectMainExc", params).then(res => {
        console.log(res);
        this.handoverLogList.forEach(item => {
          if (item.time == shiftTime) {
            item.dataException = res.result;
          }
        });
        console.log(this.handoverLogList, "#########");
      });
    },

    /* 
      验证交班日志的主要异常情况和其他的字数限制
    */
    checkHandoverNoEmpty(list) {
      console.log(list, "---------");
      for (var i = 0; i < list.length; i++) {
        if (list[i].mainExc != null && list[i].mainExc.length > 256) {
          this.$message({
            message: "主要异常情况不能超过256个字符",
            type: "error"
          });
          return false;
        } else if (list[i].other != null && list[i].other.length > 512) {
          this.$message({
            message: "其他不能超过512个字符",
            type: "error"
          });
          return false;
        }
      }
    }
  },
  created() {
    this.nursingGroupId = sessionStorage.getItem("nursingGroupId"); //获取护工组id
    console.log(this.nursingGroupId, "------------------");
  },
  mounted() {
    this.selectPlans(); //按交班班次查询
    //延迟加载
    this.$nextTick(() => {
      setTimeout(() => {
        this.selectByDate(); //按日期查询交班日志
      }, 500);
    });
  }
};
</script>
<style lang="scss" scoped>
.nursinghandoverlog {
  min-width: 1360px;
  min-height: 900px;
  background: #fefefe;
}
</style>
